import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { useAuth } from "@/context/AuthContext";
import LanguageToggle from "@/components/language-toggle";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role === "admin") nav("/admin");
      else if (u.role === "staff") nav("/staff");
      else nav("/app");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f6f2ea] flex flex-col">
      <header className="max-w-7xl mx-auto w-full px-6 md:px-10 py-6 flex justify-between items-center">
        <Link data-testid="login-back-btn" to="/" className="inline-flex items-center gap-2 text-[#0d3b66] text-sm hover:opacity-70"><ArrowLeft size={16}/> {t.common.back}</Link>
        <LanguageToggle />
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md fade-up">
          <h1 className="font-serif-display text-4xl">{t.login.title}</h1>
          <p className="text-[#3b4b5a] mt-2 text-sm">{t.login.sub}</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input data-testid="login-email" required type="email" placeholder={t.login.email} value={email} onChange={(e) => setEmail(e.target.value)} className="input" />
            <input data-testid="login-password" required type="password" placeholder={t.login.password} value={password} onChange={(e) => setPassword(e.target.value)} className="input" />
            <button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full px-6 py-3.5 rounded-full bg-[#0d3b66] text-[#f4a261] font-medium disabled:opacity-60 hover:bg-[#071f36]">
              {loading ? t.common.loading : t.login.submit}
            </button>
          </form>
          <div className="mt-6 flex items-center justify-between text-sm">
            <Link data-testid="login-goto-apply" to="/apply" className="text-[#0d3b66] underline">{t.login.newHere}</Link>
          </div>
        </div>
      </main>
      <style>{`
        .input { width:100%; padding:12px 16px; border-radius:12px; background:white; border:1px solid #e6dfd2; font-size:14px; outline:none; }
        .input:focus { border-color:#0d3b66; box-shadow:0 0 0 3px rgba(13,59,102,0.08); }
      `}</style>
    </div>
  );
}
